module.exports = __webpack_public_path__ + "media/images/dummy-car-show-carousel-98bec81bfee701bd558e3695b675ded6.jpg";